module.exports = __webpack_public_path__ + "statics/img/8.951c434.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home/8.png
// module id = 9wHH
// module chunks = 1